@if (isStatusOpen) {
  <div class="overlay" (click)="toggleModal()"></div>
  <div class="sort-container">
    <div class="sort-item" *ngFor="let item of sortingTypeDictionary" (click)="toggleModal(item)">
      <div class="text">
        <span>{{ item | translate | formatEnum | capitalize }}</span>
      </div>
    </div>
  </div>
}
<div class="button-wrapper">
  <div class="button" (click)="toggleModal()">
    <div class="button-text">
      <span>{{ 'UTILITY_COUNTRY' | translate }}</span>
    </div>
    <div class="sort-type">
      <span >
        {{ selectedOption | translate | formatEnum | capitalize }}
      </span>
    </div>
    <div><img alt="Status" src="assets/core/table-button/sort.svg" /></div>
  </div>
</div>